import { render, staticRenderFns } from "./uOttawa1321Prelab5Q4.vue?vue&type=template&id=478bf3bb&scoped=true&"
import script from "./uOttawa1321Prelab5Q4.vue?vue&type=script&lang=js&"
export * from "./uOttawa1321Prelab5Q4.vue?vue&type=script&lang=js&"
import style0 from "./uOttawa1321Prelab5Q4.vue?vue&type=style&index=0&id=478bf3bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478bf3bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VBtnToggle,VCheckbox,VForm,VImg,VRadio,VRadioGroup,VRow,VSelect})
